import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { ShieldCheck, Plus, BookOpen } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Props {
  onCreate: () => void;
  onLearn?: () => void;
}

export function ProtectionEmptyState({ onCreate, onLearn }: Props) {
  useLanguage();
  return (
    <div className="bg-white border border-dashed border-[#C7D2FE] rounded-2xl py-16 px-6 flex flex-col items-center text-center">
      <div className="w-16 h-16 rounded-full bg-[#EEF2FF] flex items-center justify-center mb-5">
        <ShieldCheck className="w-8 h-8 text-[#4B7BFF]" />
      </div>
      <h3 className="text-[20px] font-semibold text-[#111827]">
        {translateInterfaceText("Nenhuma proteção criada ainda")}</h3>
      <p className="text-[14px] text-[#6B7280] mt-2 max-w-md">
        {translateInterfaceText("Crie uma proteção para controlar quem pode assistir sua VSL, bloquear tráfego suspeito e redirecionar acessos inválidos para um vídeo alternativo.")}</p>
      <div className="flex flex-col sm:flex-row gap-3 mt-6">
        <Button
          onClick={onCreate}
          data-create-protection-btn
          className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-semibold h-10 px-5 rounded-lg"
        >
          <Plus className="w-4 h-4 mr-2" />
          {translateInterfaceText("Criar minha primeira proteção")}</Button>
        {onLearn && (
          <Button
            variant="outline"
            onClick={onLearn}
            className="h-10 px-5 rounded-lg border-[#E5E7EB] text-[#374151] bg-white transition-all active:bg-[#F9FAFB] shadow-sm hover:bg-white hover:text-[#374151] hover:border-[#E5E7EB]"
          >
            <BookOpen className="w-4 h-4 mr-2" />
            {translateInterfaceText("Ver como funciona")}</Button>
        )}
      </div>
    </div>
  );
}
